import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnlyNumbersDirective } from './only-numbers.directive';
import { DecimalOnlyDirective } from './decimal-only.directive';


@NgModule( {
  declarations: [
    OnlyNumbersDirective,
    DecimalOnlyDirective,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    OnlyNumbersDirective,
    DecimalOnlyDirective
  ]
} )
export class DirectivesModule {}
